import React from 'react'
import { useTranslation } from 'react-i18next'
import { css, StyleSheet } from 'aphrodite'
import Container from 'components/ui/Container'
import AppointmentButton from 'components/ui/buttons/AppointmentButton'
import EmergencyButton from 'components/ui/buttons/EmergencyButton'
import SelectPersonType from 'components/ui/selects/SelectPersonType'
import SelectRegion from 'components/ui/selects/SelectRegion'
import SelectTreatment from 'components/ui/selects/SelectTreatment'
import useResponsive from 'hooks/useResponsive'
import ucfirst from 'utils/ucfirst'

export default () => {
  const { t } = useTranslation()
  const { compareTag } = useResponsive()
  const styles = StyleSheet.create({
    lineHeight: {
      lineHeight: compareTag('md') ? '66.125px' : '32px',
    },
  })
  const textStyles = `${css(styles.lineHeight)} h-full tw-text-2xl-5 tw-font-thin md:tw-text-5xl`

  return (
    <Container>
      <div className="tw-col-start-2 tw-col-span-12 lg:tw-col-start-3 lg:tw-col-span-8 tw-mt-16 tw-pt-2">
        <h1>
          <span className="tw-text-dark-green tw-text-3xl md:tw-text-7xl tw-uppercase tw-tracking-wide tw-font-bold tw-mb-2">
            {t('there-for-you')}
          </span>
        </h1>
        <div className={textStyles}>
          {ucfirst(t('i-wish'))}
        </div>
        <div className={textStyles}>
          {t('for')}
          {' '}
          <SelectTreatment big />
        </div>
        <div className={textStyles}>
          {t('for')}
          {' '}
          <SelectPersonType big />
        </div>
        <div className={`${textStyles} tw-my-4`}>
          {ucfirst(t('where'))}
          {' ? '}
          <SelectRegion big />
        </div>
        <div className="tw-grid tw-grid-cols-12">
          <div className="tw-col-span-12 md:tw-col-span-6 xl:tw-col-span-5 2xl:tw-col-span-4 tw-mb-4">
            <AppointmentButton step={2} />
          </div>
          <div className="tw-col-span-12 md:tw-col-span-6 xl:tw-col-span-5 2xl:tw-col-span-4 tw-mb-4">
            <EmergencyButton />
          </div>
        </div>
      </div>
    </Container>
  )
}
